module.exports = __webpack_public_path__ + "static/img/logo_x2.160dd8f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/department/logo_x2.png
// module id = aDy3
// module chunks = 1